import moment from 'moment';
import Actions from '@/libraries/apiActions.js';
import validation from '@/libraries/validFormat';
import { buildCanonicalUrl } from '@/utils/seo';

function getBreadcrumbJson() {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: window.location.origin,
    }, {
      '@type': 'ListItem',
      position: 2,
      name: 'Jobs',
      item: window.location.origin + '/jobs',
    }, {
      '@type': 'ListItem',
      position: 3,
      name: window.location.pathname.split('/').pop(),
      item: window.location.href,
    }],
  };
}

export default {
  data() {
    return {
      modals: { open: 'exit' },
      action: new Actions(),
      rec_jobs: [],
      jobs: [],
      seo_title: '',
      meta_desc: '',
      meta_keyword: '',
      filter: {
        job_role: null,
        city_id: null,
        offset: 0,
        limit: 9,
      },
      show: 4,
      load_more: 0,
      job_flag: 0,
      total: 0,
      limit: 4,
      validate: new validation(),
      job: null,
      qualification: '',
      last_date_ts: null,
      jobLocation: [],
      courses: [],
      branches: [],
      cities: [],
      all_cities: [],
      jobrole: null,
      job_type: [
        { value: 1, text: 'Full Time' },
        { value: 2, text: 'Work from Home' },
        { value: 3, text: 'Hybrid' },
        { value: 4, text: 'Part Time' },
        { value: 5, text: 'Internship' },
        { value: 6, text: 'Apprenticeship' },
      ],
      exp: [
        { value: 1, text: '0 Month(Fresher)' },
        { value: 2, text: '06 Months' },
        { value: 3, text: '1 Year' },
        { value: 4, text: '2 year' },
        { value: 5, text: '3 year' },
        { value: 6, text: '4 year' },
        { value: 7, text: '5 year' },
        { value: 8, text: '6 year' },
        { value: 9, text: '6+ year' },
      ],
      apply_job: {
        job_id: null,
        candidate_id: null,
        status: 0,
        applier_id: null,
        applier_type: 'C',
        company_id: 1,
        src: null,
      },
      c_job_type: null,
      open: null,
      user: null,
      applied: false,
      questionnaire: [],
      hasQuestionnaire: false,
      botOptions: { botTitle: 'Questionnaire' },
      isApply: false,
      botTyping: false,
      inputDisable: true,
      question_index: 0,
      results: [],
      expired: false,
      loading: true,
      redirect_from: null,
      jobs_loading: true,
      gender: {
        options: [
          { value: 1, text: 'Male' },
          { value: 2, text: 'Female' },
          { value: 3, text: 'Both' },
        ],
      },
      error: false,
      err_msg: null,
      showDismissibleAlert: false,
      readmore: false,
      q_result: 0,
      fq_course: '',
      fq_city: '',
      faqs: [],
      is_mobile: false,
      user_gender: '',
    };
  },
  async beforeMount() {
    const url = this.$route.path;
    const urlSplit = url.split('-');
    const id = urlSplit[urlSplit.length - 1];
    const seeker = this.$cookies.get('hire-seeker');
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.is_mobile = true;
    }
    this.getJobDetails(id);
    if (seeker) {
      this.action.getUser(this.$cookies.get('hire-seeker').token).then((res) => {
        if (res) {
          this.user = res.user;
          this.getAppliedJobList();
        }
      });
      this.getUser();
    }
    await this.getCities();
    this.getQuestionnaire(id);
  },
  methods: {
    jobDetailMetaInfo(vue) {
      const job = vue.job;
      const job_type = vue.c_job_type;
      const qualification = vue.qualification;
      const last_date_ts = vue.last_date_ts;
      const jobLocation = vue.jobLocation;
      const seo_title = vue.seo_title;
      const meta_desc = vue.meta_desc;
      const meta_keyword = vue.meta_keyword;
      const faqs = vue.faqs;
      const jobrole = vue.jobrole;
      const expired = vue.expired;
      const canonicalPath = vue.jobDetailCanonicalPath || ('jobs/' + vue.$route.params.job);

      return {
        title: seo_title ? seo_title : '',
        meta: [
          { name: 'description', content: meta_desc ? meta_desc : '' },
          { name: 'keywords', content: meta_keyword ? meta_keyword : '' },
          ...(vue.jobDetailPreview ? [{ name: 'robots', content: 'noindex, nofollow' }] : []),
          ...(job && last_date_ts && (last_date_ts + (60 * 24 * 60 * 60) < Math.floor(Date.now() / 1000))
            ? [{ name: 'robots', content: 'noindex, nofollow' }]
            : []),
        ],
        link: [{ rel: 'canonical', href: buildCanonicalUrl(canonicalPath) }],
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'http://schema.org/',
              '@type': 'JobPosting',
              identifier: {
                '@type': 'PropertyValue',
                name: 'Hireclap Job ID',
                value: `${job ? job.job_id : ''}`,
              },
              datePosted: `${job ? new Date(job.date_of_posting * 1000).toISOString().replace('Z', '+05:30') : ''}`,
              validThrough: `${job ? new Date(last_date_ts * 1000).toISOString().replace('Z', '+05:30') : ''}`,
              title: `${job ? job.job_designation : ''}`,
              description: `${job ? job.job_description : ''}`,
              employmentType: `${job_type ? job_type.toUpperCase().replace(/ /g, '_') : ''}`,
              industry: `${jobrole ? jobrole.role : 'Private'}`,
              qualifications: `${qualification ? qualification : ''}`,
              hiringOrganization: {
                '@type': 'Organization',
                name: `${job ? job.company_name : ''}`,
                ...(job && job.company_logo_url && {
                  logo: `${process.env.VUE_APP_S3_URL}${job.company_logo_url}`,
                }),
                ...(job && job.website_url && { sameAs: `${job.website_url}` }),
              },
              jobLocation,
              applicantLocationRequirements: { '@type': 'Country', name: 'India' },
              baseSalary: {
                '@type': 'MonetaryAmount',
                currency: 'INR',
                value: {
                  '@type': 'QuantitativeValue',
                  minValue: parseInt(`${job ? (job.salary_range_from ? parseInt(job.salary_range_from, 10) : 0) : ''}`, 10),
                  maxValue: parseInt(`${job ? (job.salary_range_to ? parseInt(job.salary_range_to, 10) : parseInt(job.salary_range_from, 10)) : ''}`, 10),
                  unitText: 'MONTH',
                },
              },
              ...(expired ? { availability: 'https://schema.org/JobClosed' } : {}),
            },
          },
          ...(faqs.length ? [{
            type: 'application/ld+json',
            json: {
              '@context': 'http://schema.org/',
              '@type': 'FAQPage',
              mainEntity: faqs.map(item => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: { '@type': 'Answer', text: item.answer },
              })),
            },
          }] : []),
          { type: 'application/ld+json', json: getBreadcrumbJson() },
        ],
      };
    },
    calculatePostDate(date) {
      return moment(new Date(date * 1000)).fromNow();
    },
    openModal(type = '') {
      this.open = type === '' ? this.open : type;
      if (this.open === 'success') {
        this.$refs['apply-success'].show();
      }
      this.modals.open = 'exit';
      this.modals.open = type;
    },
    hideModal(name) {
      this.$refs[name].hide();
      this.$router.push('/jobs');
    },
    getUser() {
      this.action.getUser(this.$cookies.get('hire-seeker').token).then((res) => {
        this.apply_job.candidate_id = res.user.id;
        this.apply_job.applier_id = res.user.id;
      });
    },
    loadmore() {
      this.load_more++;
      if (this.load_more === 1) {
        this.filter.offset += 4;
        this.show += 4;
      } else {
        const routeData = this.$router.resolve({ name: 'JobList' });
        window.open(routeData.href, '_blank');
      }
    },
    getAppliedJobList() {
      this.action.getAppliedJobList(this.user.id, this.$cookies.get('hire-seeker').token).then((res) => {
        res.applied_jobs.forEach((appliedJob) => {
          if (this.job && this.job.job_id === appliedJob.job_id) {
            this.applied = true;
          }
        });
      });
    },
    async getCities() {
      await this.action.getCities().then(async (data) => {
        if (data.cities) {
          await data.cities.forEach((element) => {
            this.all_cities.push({ value: element.city_id, text: element.city_name });
          });
        }
      });
    },
    similiarJobs() {
      this.action.getJobList(this.filter).then(async (res) => {
        this.jobs = res.jobs;
        this.total = res.meta.total;
        if (this.total < 8) {
          await this.action.getJobList({ limit: 9 }).then((fallback) => {
            fallback.jobs.forEach((similarJob) => {
              if (!this.hasDupes(this.jobs, similarJob.job_id)) {
                this.jobs.push(similarJob);
              }
            });
          });
        }
        this.jobs_loading = false;
        this.jobs = this.jobs.filter(similarJob => similarJob.job_id !== this.job.job_id);
        this.jobs.forEach((similarJob) => {
          similarJob.last_date = this.validate.convertTimestamp(similarJob.last_date);
          similarJob.date_of_posting = this.validate.convertTimestamp(similarJob.date_of_posting);
          let param = similarJob.job_url ? similarJob.job_url : '';
          param = param.replace(/[^A-Z0-9]+/ig, '-');
          if (param.length > 80) {
            const paramSplit = param.split('-');
            const idLength = paramSplit[paramSplit.length - 1].length;
            param = `${param.substring(0, 80 - (idLength + 1))}-${paramSplit[paramSplit.length - 1]}`;
          }
          similarJob.param = param;
        });
      });
    },
    hasDupes(array, value) {
      return array.some(a => a.job_id === value);
    },
    getJobDetails(id) {
      this.action.getJobDetailsId({ id }).then((res) => {
        this.loading = false;
        this.job = res.data[0];
        this.seo_title = this.job.seo_title;
        this.meta_desc = this.job.seo_description;
        this.meta_keyword = this.job.seo_keywords;
        this.apply_job.job_id = this.job.job_id;
        this.last_date_ts = this.job.last_date;
        this.job.last_date = this.validate.convertTimestamp(this.job.last_date);
        if (this.last_date_ts >= new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000) {
          this.expired = false;
        } else {
          this.expired = true;
        }
        this.job.courses.forEach((course, i) => {
          this.qualification += course.name;
          if (this.job.courses.length !== i + 1) {
            this.qualification += ',';
          }
          this.courses.push(course.name);
          course.branches.forEach((branch) => {
            this.branches.push(course.name + '-' + branch);
          });
        });
        this.filter.city_id = this.getIdsfromNames(this.job.cities, this.all_cities);
        this.filter.job_role = this.job.job_role;
        this.job.cities.forEach((city) => {
          this.jobLocation.push({
            '@type': 'Place',
            address: {
              '@type': 'PostalAddress',
              addressLocality: city,
              addressRegion: city,
              streetAddress: city,
              postalCode: '-',
              addressCountry: 'India',
            },
          });
        });
        this.getJobrole();
        this.getJobType();
        this.similiarJobs();
        this.addFaqs();
      });
    },
    addFaqs() {
      this.faqs = [];
      this.fq_course = '';
      this.fq_city = '';
      this.faqs.push(
        { question: 'How to apply for this job?', answer: '<p> You can apply for this job simply by clicking on the "Apply now" button on this page. If you are new to our website, you can register by filling in your basic details, verifying your account, and then apply for jobs.</p>' },
        { question: 'Do I have to complete my profile to apply for this job?', answer: '<p> We strongly recommend completing your profile with all the necessary information. Our AI-driven system uses that information to match your applications for the jobs. Fully completed profiles will have a higher probability of shortlisting for further recruitment.</p>' },
        { question: 'How to know that I am shortlisted/selected for the job?', answer: '<p>Most of the companies intimate the shortlisted /selected candidates only. Sometimes the email may land in your promotions/spam folders also. Suggest checking those folders too. If you are not hearing back from the employer for a long time, high chance that the company does not shortlist you. Continue applying for more matching <a href="/jobs" target="_blank">jobs</a></p>' },
        { question: 'When can I expect to hear back from the company?', answer: '<p>Typically the hiring companies intimate the selected candidates within a week from the last date of application. This duration varies from company to company, depending on their recruitment process. </p>' },
        { question: 'Do all applications go directly to the employer?', answer: '<p>Yes, all the applications are visible only to the company. The selection process is completely managed directly by the company.</p>' }
      );
      if (this.job.salary_flag === 0 && this.job.salary_range_from) {
        if (this.job.salary_range_to) {
          this.faqs.push({ question: 'What salary can I expect for this job?', answer: `<p>The offered monthly salary is INR${this.job.salary_range_from}<span>to INR ${this.job.salary_range_to}</span> as per the job description. The salary offer also depends on factors like your interview performance, skills, experience, etc. </p>` });
        } else {
          this.faqs.push({ question: 'What salary can I expect for this job?', answer: `<p>The offered monthly salary is INR${this.job.salary_range_from} as per the job description. The salary offer also depends on factors like your interview performance, skills, experience, etc. </p>` });
        }
      }
      if (this.job.courses.length) {
        this.job.courses.forEach((course, index) => {
          if (course.branches.length) {
            course.branches.forEach(branch => {
              this.fq_course += course.name + '-' + branch;
              if (course.branches.length !== index + 1) {
                this.fq_course += ',';
              }
            });
          } else {
            this.fq_course += course;
          }
          if (this.job.courses.length !== index + 1) {
            this.fq_course += ',';
          }
        });
        this.faqs.push({ question: 'What is the highest qualification to apply for this job?', answer: `<p>Candidates who completed ${this.fq_course} can apply for this job. Please check other eligibility criteria also before applying for the job.</p></p>` });
      }
      if (this.job.cities.length) {
        this.job.cities.forEach((city, index) => {
          this.fq_city += city;
          if (this.job.cities.length !== index + 1) {
            this.fq_city += ',';
          }
        });
        this.faqs.push({ question: 'Is this job vacancy available only for the mentioned location(s)?', answer: `<p>Yes, this recruitment is for ${this.fq_city}.To find jobs near your city check out Jobs in city</p>` });
      }
      if (this.job.job_type) {
        this.faqs.push({ question: 'What type of job is this?', answer: `<p>It is a ${this.c_job_type}<br> For more details, please read the job description provided by the employer to know about the roles and responsibilities of this position.</p>` });
      }
      if (this.job.number_of_vacancy) {
        this.faqs.push({ question: 'What are the skills required for this job?', answer: '<p>The candidate should have the following skills:</p>' });
        this.faqs.push({ question: 'What is the number of vacancies for this job?', answer: `<p>The number of vacancies available right now for this job is ${this.job.number_of_vacancy}.</p>` });
      }
      if (this.job.hiring_process) {
        this.faqs.push({ question: 'What is the Hiring Process for this job?', answer: `<p>The hiring for this job is through ${this.job.hiring_process}.</p>` });
      }
      if (this.job.last_date) {
        this.faqs.push({ question: "What's the last date to apply??", answer: `<p>The last date to apply for this job is ${this.job.last_date}. Recommend to apply for the job before this date to avoid a last-minute rush and changes in deadlines.</p>` });
      }
    },
    getJobrole() {
      this.action.getJobrole().then((res) => {
        res.jobroles.forEach((role) => {
          if (role.role_id === this.job.job_role) {
            this.jobrole = role;
          }
        });
      });
    },
    getJobType() {
      this.job_type.forEach((type) => {
        if (type.value === this.job.job_type) {
          this.c_job_type = type.text;
        }
      });
    },
    getJobExp(exp1, exp2) {
      let displayExp = '';
      let experienceFrom = '';
      let experienceTo = '';

      if (exp1 === null) {
        experienceFrom = '0';
      } else if (exp1 === 0) {
        experienceFrom = '0 Month';
      } else if (exp1 > 0 && exp1 < 12) {
        experienceFrom = exp1 + ' Months';
      } else if (exp1 === 84) {
        experienceFrom = '6+ Years';
      } else {
        experienceFrom = (exp1 / 12) + ' Years';
      }

      if (exp2 === 0 || exp2 === null) {
        experienceTo = '0';
      } else if (exp2 > 0 && exp2 < 12) {
        experienceTo = exp2 + ' Months';
      } else if (exp2 === 84) {
        experienceTo = '6+ Years';
      } else {
        experienceTo = (exp2 / 12) + ' Years';
      }

      if (experienceFrom === '0' && experienceTo === '0') {
        displayExp = '';
      } else if (exp2 === exp1) {
        displayExp = experienceTo;
      } else {
        displayExp = ((experienceFrom !== null) ? experienceFrom : '') + ((experienceFrom !== null && experienceTo !== '0' && experienceTo !== null) ? ' to ' : '') + (experienceTo !== '0' && experienceTo !== null ? experienceTo : '');
      }
      return displayExp;
    },
    checkCity() {
      if (this.$cookies.get('hire-seeker')) {
        if (this.user && (this.job.cities.includes(this.user.personal_details.user_city.city_name) || this.job.cities.includes('Anywhere in India'))) {
          if (this.job.response_type === 1) {
            this.applyJob();
          } else if (this.job.response_type === 2) {
            this.newTab(this.job.link1);
          }
        } else {
          this.$refs.city_alert.show();
        }
      } else {
        this.redirect_from = this.$route.path;
        const url = '/jobseeker/register?src=' + this.apply_job.src + '&&redirect_from=' + this.redirect_from;
        window.open(url, '_blank').focus();
      }
    },
    applyJob() {
      this.apply_job.src = this.$route.query.src ? this.$route.query.src : 'hire-job';
      if (!this.apply_job.src.includes('-jobid')) {
        this.apply_job.src += '-jobid' + this.job.job_id;
      }
      this.error = false;
      if (this.job.response_type === 1) {
        this.action.applyJob(this.apply_job).then((res) => {
          if (res.status === 1) {
            this.$refs.city_alert.hide();
            if (this.hasQuestionnaire) {
              this.isApply = true;
              this.$router.push('/questionnaire/' + this.job.job_id);
            } else {
              this.openModal('success');
              setTimeout(() => {
                this.$refs['apply-success'].hide();
              }, 3000);
            }
            this.applied = true;
          }
        }).catch(() => {
          this.error = true;
          if (window.navigator.onLine) {
            this.err_msg = 'System error! Please try again.';
          } else {
            this.err_msg = 'Network error! Please check your internet connection.';
          }
        });
      } else if (this.job.response_type === 2) {
        this.newTab(this.job.link1);
      }
    },
    getIdsfromNames(names, arr) {
      const res = [];
      names.forEach(name => {
        arr.forEach(item => {
          if (item.text === name) res.push(item.value);
        });
      });
      return res;
    },
    newTab(url) {
      if (!url.match(/^https?:\/\//i)) {
        url = 'https://' + url;
      }
      if (this.$cookies.get('hire-seeker')) {
        window.open(url, '_blank').focus();
      } else {
        this.redirect_from = url;
        const regUrl = '/jobseeker/register?src=' + this.apply_job.src + '&&redirect_from=' + this.redirect_from;
        window.open(regUrl, '_blank').focus();
      }
    },
    getQuestionnaire(id) {
      const uid = this.$cookies.get('hire-seeker') ? this.user?.id : null;
      this.action.existQuestionnaire(id, uid).then(res => {
        if (res.status === true) {
          this.hasQuestionnaire = true;
          this.q_result = res.result;
        } else {
          this.hasQuestionnaire = false;
        }
      });
    },
    async copyToClipboard() {
      await navigator.clipboard.writeText(window.location.href);
      this.showDismissibleAlert = true;
      setTimeout(() => {
        this.showDismissibleAlert = false;
      }, 3000);
    },
    getGender(id) {
      this.gender.options.forEach((g) => {
        if (g.value === id) {
          this.user_gender = g.text;
        }
      });
      return this.user_gender;
    },
    getDate(ts) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const date = new Date(ts * 1000);
      return this.pad(date.getDate()) + '-' + months[date.getMonth()] + '-' + date.getFullYear();
    },
    pad(n) {
      return n < 10 ? '0' + n : n;
    },
  },
};
